module.exports = __webpack_public_path__ + "static/media/markus-spiske-187777.81fc98ba.jpg";